import Button from "../../../../../common/components/atom/Button/Button";
import { useSingleMinigrid } from "../../../hook";
import { PenIcon } from "../../../../../common/assets/icons";
import { PermissionTooltip, useCapability } from "../../../../rbac";



export default function EditBtnMinigridPresenter() {
  const {singleMinigridQuery:{data}} = useSingleMinigrid()
  const canEdit = useCapability('equipment.edit')

  if (!data){
    return <></>
  }
  return (
        <PermissionTooltip allowed={canEdit}>
          <Button
        label="Modifier"
        IconComponentLeft={() => <PenIcon />}
        linkTo={"/main/minigrid/"+data.minigrid_id+"/edit"}
        disabled={!canEdit}
        variant={"tercery"}/>
        </PermissionTooltip>
  )
}
